module.exports = "https://r.nearpod.com/assets/media/image/poll-a472cf2fba4e21704830191111408370.svg";